/**
 * OAuth / auth callback, cookie is set server-side; just hydrate /me and redirect.
 */
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { finishAuthRedirect } from '@/config/hosts';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useAuth();
  const [message, setMessage] = useState('Signing you in…');

  useEffect(() => {
    const error = searchParams.get('error');
    if (error) {
      setMessage('Sign-in failed. Redirecting…');
      const t = setTimeout(() => navigate(`/auth?error=${encodeURIComponent(error)}`, { replace: true }), 800);
      return () => clearTimeout(t);
    }

    // Ignore legacy ?token= if somehow present, never store it
    if (searchParams.get('token')) {
      window.history.replaceState({}, document.title, '/auth/callback');
    }

    (async () => {
      try {
        const user = await refreshUser();
        if (user) {
          finishAuthRedirect(navigate, '/app');
          return;
        }
        setMessage('Could not confirm session. Redirecting to login…');
        navigate('/auth', { replace: true });
      } catch (_) {
        navigate('/auth', { replace: true });
      }
    })();
  }, [navigate, refreshUser, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <p className="text-slate-600 text-sm">{message}</p>
    </div>
  );
}
